import styled from "@emotion/styled";

export const Pre = styled.pre`
  white-space: normal;
  word-wrap: break-word;
`;

export const Aligner = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
`;

export const Spacer = styled.div`
  margin-top: 24px;
`;
